export default "__VITE_ASSET__DBQql1$___"